import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './Login.css';
import {getErrorTranslation} from "../utils/errorUtils";

const Login: React.FC = () => {
	const { t } = useTranslation();
	const [userName, setUserName] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [error, setError] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const { login } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
		e.preventDefault();
		setError('');
		setLoading(true);

		const result = await login(userName, password);

		if (result.success) {
			const userType = localStorage.getItem('userType');
			const storedSchoolId = localStorage.getItem('schoolId');

			if (userType === 'SUPER_ADMIN') {
				navigate('/courses');
			} else if (storedSchoolId) {
				navigate('/courses');
			} else {
				setError(t('school.idRequired'));
				setLoading(false);
				return;
			}
		} else {
			setError(result.error || t('login.invalidCredentials'));
		}

		setLoading(false);
	};

	return (
		<div className="login-container">
			<div className="login-box">
				<h2>{t('login.title')}</h2>
				<h3>{t('common.login')}</h3>
				<form onSubmit={handleSubmit}>
					<div className="form-group">
						<label>{t('login.username')}</label>
						<input
							type="text"
							value={userName}
							onChange={(e) => setUserName(e.target.value)}
							required
							disabled={loading}
						/>
					</div>
					<div className="form-group">
						<label>{t('login.password')}</label>
						<input
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
							disabled={loading}
						/>
					</div>
					{error && <div className="error-message">{getErrorTranslation(error, t)}</div>}
					<button type="submit" disabled={loading}>
						{loading ? t('login.loggingIn') : t('login.submit')}
					</button>
				</form>
			</div>
		</div>
	);
};

export default Login;
